<template>
  <div class="flex flex-col justify-between prices">
    <div>
      <header class="mint-header grid-cols-3">
        <router-link :to="resolveReturn()" class="justify-self-start">
          <i class="material-icons">arrow_back_ios_new</i>
        </router-link>
        <span class="col-start-2">Carpe Diem {{ account }}</span>
      </header>

      <div v-if="from === 'Habits'" class="px-10px pt-5 text-sm">
        Your habit building is impressive! But there's bad news, you've reached
        the
        <span class="font-bold">{{ accountIsFree ? 5 : 20 }} habits limit</span>
        for your account plan.
        <div class="mt-4">
          On a positive note, if you upgrade, then you'll be able to build way
          more habits! And I'll be able to buy some more bread. Everyone wins.
        </div>
      </div>

      <div v-else class="px-10px pt-5 text-sm">
        How is the habit building going? Hopefully this app has helped you with
        building positive habits and destroying negative ones.
        <div v-if="accountIsFree || accountIsPro" class="mt-4">
          As a <span class="font-bold">Carpe Diem {{ account }}</span> user, you
          have a {{ accountIsFree ? 5 : 20 }} habit limit. Your current usage is
          <span class="font-bold"
            >{{ habitsLength }} / {{ accountIsFree ? 5 : 20 }}</span
          >
        </div>
        <div v-else class="mt-4">
          As a Carpe Diem {{ account }} user, you have
          <span class="font-bold">no habit limits.</span>
          Keep up the momentum and thank you for believing in the app!
        </div>
      </div>
    </div>

    <div>
      <div
        v-if="accountIsFree"
        class="flex flex-col items-center justify-center px-10"
      >
        <stripe-button
          name="Carpe Diem PRO"
          description="20 habits for life"
          :amount="149"
        >
          Get Carpe Diem PRO 💪
        </stripe-button>
        <span class="text-sm mt-3">20 habits for life — 149 CZK</span>
      </div>

      <div
        v-if="accountIsFree || accountIsPro"
        class="flex flex-col items-center justify-center p-10"
      >
        <stripe-button
          name="Carpe Diem LIFE"
          description="Unlimited habits for life"
          :amount="299"
        >
          Get Carpe Diem LIFE 🚀
        </stripe-button>
        <span class="text-sm mt-3">Unlimited habits for life — 299 CZK</span>
      </div>
    </div>
  </div>
</template>

<script>
import userModule from '@/store/modules/user.module'
import habitModule from '@/store/modules/habit.module'
const StripeButton = () => import('@/components/StripeButton')

export default {
  name: 'Prices',

  components: { StripeButton },

  data() {
    return {
      from: this.$route.params.from
    }
  },

  computed: {
    user: userModule.user,
    habits: habitModule.habits,
    account: userModule.account,
    accountIsFree: userModule.accountIsFree,
    accountIsPro: userModule.accountIsPro,

    habitsLength() {
      return this.habits.length
    }
  },

  methods: {
    resolveReturn() {
      if (this.from === 'Habits') return 'habits'

      return 'about'
    },

    upgrade(type) {
      console.log(type)
    }
  }
}
</script>

<style lang="scss" scoped>
.mint-header {
  display: grid !important;
  height: 62px;
  .a-icon {
    outline: none;
    text-decoration: none !important;
    display: flex;
    align-items: center;
    justify-content: center;
    i {
      font-size: 18px;
    }
  }
}
.prices {
  height: calc(100vh - 62px);
}
.px-10px {
  padding-left: 10px;
  padding-right: 10px;
}
.font-18px {
  font-size: 18px;
}
.h-62px {
  height: 62px;
}
</style>
